import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/helpSupport.css';

/**
 * Persistent, deliberately subtle help entry point rendered by Footer.js (so it appears on every
 * POS page via MainLayout) - links to /support rather than opening anything inline, since the
 * support options (phone/email/WhatsApp) are simple static links with no need for a modal.
 */
const HelpButton = () => (
  <Link
    to="/support"
    className="helpBtn"
    title="Help & Support"
    aria-label="Help & Support"
  >
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3" />
      <circle cx="12" cy="17" r="0.25" fill="currentColor" stroke="currentColor" />
    </svg>
    <span className="helpBtnLabel">Need help?</span>
  </Link>
);

export default HelpButton;
